import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';

import { useUserStore } from "@/stores/user";
import { afterEachGuard } from './guards/after-each';
import { beforeEachGuard } from './guards/before-each';

// Dynamic imports used for code-splitting
// Update vite.config.ts to group chunks together on build

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'ui.home',
    component() {
      return import('@/views/Home.vue')
    },
  },

  {
    path: '/create-new-concepts',
    name: 'Create New Concepts',
    component() {
      return import('@/views/internal/CreateNewConcepts.vue')
    },
  },

  // {
  //   path: '/module/:moduleId',
  //   props: true,
  //   component() {
  //     return import('@/views/Module.vue')
  //   },
  //   children: [
  //     {
  //       path: 'component/:componentTypeId',
  //       props: true,
  //       component() {
  //         return import('@/views/Component.vue')
  //       }
  //     }
  //   ]
  // },

  // ===========================

  {
    // fallback
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },

];


///////////////////////////////////////////////////

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   const userStore = useUserStore();
    
  //   const finalPosition = savedPosition ? savedPosition : { top: 0 };
    
  //   userStore.route.savedPosition = finalPosition;
    
  //   return finalPosition;
    
  //   // https://router.vuejs.org/guide/advanced/scroll-behavior.html
  //   // Returning the savedPosition will result in a native-like behavior when navigating with back/forward buttons:

  //   // If you want to simulate the "scroll to anchor" behavior:

  //   // if (to.hash) {
  //   //   return {
  //   //     el: to.hash,
  //   //     behavior: 'smooth',
  //   //   }
  //   // }
  // },
});

router.beforeEach(beforeEachGuard);
// router.afterEach(afterEachGuard);
